let sectionsToFetch = 'cart-drawer';

const CART_STATE = {
  BUSY: 'BUSY',
  READY: 'READY',
};

const CART_STATES = [
  CART_STATE.BUSY,
  CART_STATE.READY,
];

let currentCartState = CART_STATE.BUSY;

document.addEventListener('on:cart:loaded', (event) => {
  if (event.detail.type === 'ADD') {
    document.querySelector('.js-cart-drawer')?.scrollTo(0, 0, { behavior: 'smooth'})

    fetchCartDrawer(true);
  }
});

function updateCartState(state) {
  if (!CART_STATES.includes(state)){
    console.error('updateCartState(): state not found in CART_STATES');
    return;
  }

  currentCartState = state;

  const cartDrawer = document.querySelector('.js-cart-drawer');
  if (!cartDrawer) {
    console.error('Cart drawer element not found when changing state');
    return;
  }

  if (state === CART_STATE.READY) {
    cartDrawer.removeAttribute('data-is-updating');
  } else {
    cartDrawer.setAttribute('data-is-updating', 'true');
  }
}

class CartService {
  static get #base() {
    return `${window.Shopify.routes.root}cart`;
  }

  static #get(url) {
    return fetch(url).then(r => r.json());
  }

  static #post(url, body) {
    const isFormData = body instanceof FormData;
    return fetch(url, {
      method: 'POST',
      ...(isFormData ? {} : { headers: { 'Content-Type': 'application/json' } }),
      body: isFormData ? body : JSON.stringify(body),
    }).then(r => r.json());
  }

  static getCart() {
    return this.#get(`${this.#base}.js`);
  }

  static getWithSections(sections) {
    return this.#get(`${this.#base}?sections=${sections}`);
  }

  static add(data) {
    return this.#post(`${this.#base}/add.js`, data);
  }

  static change(data) {
    return this.#post(`${this.#base}/change.js`, data);
  }

  static update(data) {
    return this.#post(`${this.#base}/update.js`, data);
  }

  static clear() {
    return fetch('/cart/clear.js').then(r => r.json());
  }
}

/**
 * Fetches the cart drawer content and updates the cart drawer
 *
 * @param {Boolean} showCartDrawer - Whether to show the cart drawer
 * @param {Boolean} isShopPay - Whether the user is using Shop Pay
 * @param {Boolean} straightToCheckout - Whether the user is going straight to checkout
 */

function fetchCartDrawer(showCartDrawer = false, isShopPay = false, straightToCheckout = false) {
  if (isShopPay) {
    window.location.href = '/checkout?payment=shop_pay';
  } else if (straightToCheckout) {
    window.location.href = '/checkout?skip_shop_pay=true';
  } else {
    updateCartState(CART_STATE.BUSY);

    CartService.getWithSections(sectionsToFetch)
      .then((data) => {
        const sections = data;

        // Updates the cart drawer
        return CartService.getCart()
          .then((cartData) => {
            cartData['sections'] = sections;

            updateCartDrawer(cartData, showCartDrawer);

            if (cartData.attributes.hasOwnProperty('error_discount_codes')) {
              CartService.update({ attributes: { error_discount_codes: '' } });
            }
          });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        updateCartState(CART_STATE.READY);
      });
    }
}

/**
 * Updates the cart drawer
 *
 * @param {Object} data - The data to update the cart drawer with
 * @param {Boolean} showCartDrawer - Whether to show the cart drawer
 */
async function updateCartDrawer(data, showCartDrawer = false) {
  try {
    if (!!(data)) {
      const cartDrawer = document.querySelector('.js-cart-drawer');
      const cartModal = document.querySelector('.modal--cart');

      if (!!(cartDrawer)) {
        const cartCountBubble = document.querySelectorAll('.cart-count-bubble items-count');
        const cartDrawerHTML = new DOMParser().parseFromString(data?.sections['cart-drawer'], 'text/html');
        const cartDrawerContainer = cartDrawer.querySelector('.js-cart--draw');
        const cartDrawerFreeShippingBar = cartDrawer.querySelector('.js-cart-draw__free-shipping-bar');
        const cartDrawerMarketingMessage = cartDrawer.querySelector('.js-cart-draw__notice');
        const cartQuantityInfo = cartDrawer.querySelector('.js-cart-draw__quantity-info items-count');
        let cartControls = cartDrawer.querySelector('.js-cart__controls');

        if (Object.keys(data?.sections).length > 1) {
          for (const section of Object.entries(data?.sections)) {
            if (section[0] !== 'cart-drawer') {
              const sectionHTML = new DOMParser().parseFromString(section[1], 'text/html');
              const sectionContainer = document.getElementById(`shopify-section-${section[0]}`);

              if (!!(sectionContainer)) {
                sectionContainer.innerHTML = sectionHTML.querySelector('.shopify-section')?.innerHTML;
              }
            }
          }
        }

        if (!!(cartDrawerContainer)) {
          cartDrawerContainer.innerHTML = cartDrawerHTML.querySelector('.js-cart--draw')?.innerHTML;
        }

        const cartDrawerContent = cartDrawer.querySelector('.js-cart__contents');

        if (!!(cartQuantityInfo)) {
          if (!!(cartDrawerContent)) {
            cartQuantityInfo.innerHTML = cartDrawerHTML.querySelector('.js-cart-draw__quantity-info items-count')?.innerHTML;
          } else {
            cartQuantityInfo.innerHTML = '0';
          }
        }

        if (!!(cartCountBubble) && cartCountBubble.length > 0) {
          cartCountBubble.forEach((countBubble) => {
            if (!!(cartDrawerContent)) {
              countBubble.innerHTML = cartDrawerHTML.querySelector('.js-cart-draw__quantity-info items-count')?.innerHTML;
            } else {
              countBubble.innerHTML = '0';
            }
          });
        }

        if (!!(cartDrawerFreeShippingBar)) {
          cartDrawerFreeShippingBar.innerHTML = cartDrawerHTML.querySelector('.js-cart-draw__free-shipping-bar')?.innerHTML;
        }

        if (!!(cartDrawerMarketingMessage)) {
          cartDrawerMarketingMessage.innerHTML = cartDrawerHTML.querySelector('.js-cart-draw__notice')?.innerHTML;
        }

        if (!!cartModal) {
          if (!cartModal.shown && showCartDrawer) {
            cartModal.open();
          } else if (cartModal.interval) {
            cartModal.interval.reset();
            cartModal.interval.start();
          }
        }
        
        if (data.item_count > 0) {
          const cartItems = data?.items;

          if (cartItems.length > 0) {
            if (!cartDrawerContainer.querySelector('[data-enable-searchspring="true"]')) {
              const newRecommendations = {};
              const outputRecommendations = [];
              const productIds = cartItems.reduce(((ids, item) => {
                if (!item.gift_card && !ids.includes(item.product_id.toString())) ids.push(item.product_id.toString());
                return ids;
              }), []);
              let recommendationsLimit = 6;

              if (productIds.length >= 3) {
                recommendationsLimit = 2;
              } else if (productIds.length >= 2) {
                recommendationsLimit = 4;
              }

              await Promise.all([...productIds].map((async productId => {
                const response = await fetch(`${window.Shopify.routes.root}recommendations/products?section_id=cart-drawer-recommendations&product_id=${productId}&limit=${recommendationsLimit}&intent=related`);
                const recommendationsHTML = await response.text();
                const recommendationsJSON = new DOMParser().parseFromString(recommendationsHTML, 'text/html').querySelector('.shopify-section').textContent.trim();

                let recommendations = {};
                let qaIndex = 0;

                if (recommendationsJSON.startsWith('{') && recommendationsJSON.endsWith('}')) {
                  recommendations = JSON.parse(recommendationsJSON);
                }

                if (recommendations?.products) {
                  Object.entries(recommendations?.products)?.forEach(([key, value]) => {
                    if (!Object.keys(newRecommendations)?.includes(key.toString())) {
                      const updatedHTML = value.replaceAll('data-qa=""', `data-qa="quick-add-${key}"`);
                      qaIndex += 1;

                      outputRecommendations.push(updatedHTML);
                    }

                    newRecommendations[key.toString()] = true;
                  });

                  if (outputRecommendations.length <= recommendationsLimit) {
                    recommendationsLimit = 2;
                  }
                }
              })));

              const cartRecommendations = cartDrawerContainer.querySelector('.js-cart-recommendations');

              if (!!(cartRecommendations)) {
                if (cartRecommendations.innerHTML !== outputRecommendations.slice(0, 6).join('')) {
                  cartRecommendations.innerHTML = outputRecommendations.slice(0, 6).join('');
                }
              }
            } else {
              const recommendationsScript = cartDrawerContainer.querySelector('script[data-section-id="drawer-cart-recommendations"]');

              if (!!(recommendationsScript)) {
                const tag = recommendationsScript.dataset.tag;
                const limit = recommendationsScript.dataset.limit;
                const placement = recommendationsScript.dataset.placement;
                const recommendationsUrl = recommendationsScript.dataset.recommendationsUrl;
                const cartProductIds = recommendationsScript.dataset.cartProductIds;
                let shopper = recommendationsScript.dataset.shopper;

                if (shopper === undefined) {
                  shopper = document.cookie.split(';').find(row => row.trim().startsWith('ssShopperId='))?.split('=')[1];
                }

                var storedProducts = document.cookie.split(';').find(row => row.trim().startsWith('recentlyViewedProducts='))?.split('=')[1];
                var viewedProducts = [];
                var viewedProductIds = [];

                if (storedProducts) {
                  viewedProducts = storedProducts.split(',');

                  viewedProducts.forEach((productIdentifier) => {
                    viewedProductIds.push(productIdentifier.split(':')[1]);
                  });
                }

                fetch(`${recommendationsUrl.replace('REPLACE_TAG', tag)}&cart=${cartProductIds}&lastViewed=${viewedProductIds.join(',')}${(shopper !== undefined && shopper !== '') ? '&shopper=' + shopper : ''}`,
                  {
                    method: 'GET',
                    headers: {
                      accept: 'application/json'
                    }
                  })
                  .then((response) => response.json())
                  .then((data) => {
                    const productCardSection = document.querySelector('[data-section-id="drawer-cart-recommendations"] .grid-layout');

                    initRecommendationsSection(productCardSection, tag, data, limit, placement);
                  })
                  .catch((error) => console.error(error));
              }
            }
          }
        }

        cartControls = cartDrawer.querySelector('.js-cart__controls');

        if (!!(cartControls) && !!(cartDrawer)) {
          cartDrawer.parentElement.style.setProperty('--cart-drawer-footer-height', `${cartControls.offsetHeight}px`);
        } else if (!!(cartDrawer)) {
          cartDrawer.parentElement.style.setProperty('--cart-drawer-footer-height', `0px`);
        }
      }
    }
  } catch (error) {
    console.error(error);
  } finally {
    updateCartState(CART_STATE.READY);
  }
}

/**
 * Adds an item to the cart
 *
 * @param {FormData} formData - The form data to add the item to the cart with
 * @param {Boolean} isShopPay - Whether or not Shop Pay accelerated checkout
 *                              button was used to add the product and
 *                              therefore should have the user redirected to
 *                              checkout using Shop Pay.
 * @param {Boolean} straightToCheckout - Whether or not it should go straight
 *                                       to checkout.
 */
function cartAdd(formData, isShopPay = false, straightToCheckout = false) {
  updateCartState(CART_STATE.BUSY);

  CartService.add(formData)
    .then((data) => {
      fetchCartDrawer(true, isShopPay, straightToCheckout);
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      updateCartState(CART_STATE.READY);
    });
}

/**
 * Changes line item quantity
 *
 * @param {Object} change - The item to update
 * @param {Boolean} updateDrawer - Whether to update the cart drawer
 */
function cartChange(change, updateDrawer = true) {
  updateCartState(CART_STATE.BUSY);

  CartService.change(change)
    .then((data) => {
      // Updates the cart drawer

      if (updateDrawer) {
        updateCartDrawer(data, true);
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      updateCartState(CART_STATE.READY);
    });
}

/**
 * Updates line items
 *
 * @param {Object} updates - The items to update
 * @param {Boolean} updateDrawer - Whether to update the cart drawer
 */
function cartUpdate(updates, updateDrawer = true) {
  updateCartState(CART_STATE.BUSY);
  
  CartService.update(updates)
    .then((data) => {
      // Updates the cart drawer

      if (updateDrawer) {
        updateCartDrawer(data, true);
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      updateCartState(CART_STATE.READY);
    });
}

function initializeCartHandlers() {
  const cartControls = document.querySelector('.js-cart__controls');
  const cartDrawer = document.querySelector('.js-cart-drawer');
  const cartItemRemoves = document.querySelectorAll('.js-cart-item__remove');
  const cartModal = document.querySelector('.modal--cart');
  const quantityInputs = document.querySelectorAll('.js-cart-quantity-input');

  fetchCartDrawer(false);

  document.querySelectorAll('.shopify-section-group-gwp')?.forEach((section) => {
    sectionsToFetch += `,${section.id.replace('shopify-section-', '')}`;
  });

  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has('cart') && urlParams.get('cart') === 'true') {
    if (!!cartModal) {
      if (!cartModal.shown) {
        cartModal.open();
      } else if (cartModal.interval) {
        cartModal.interval.reset();
        cartModal.interval.start();
      }
    }
  }

  if (urlParams.has('pc')) {
    const promoCode = urlParams.get('pc');
    const sentDiscountCodes = [];

    sentDiscountCodes.push(promoCode);

    CartService.update({ discount: promoCode })
        .then((data) => {
          let appliedDiscountCode = '';
          let errorDiscountCode = '';
          let foundDiscountCodes = [];

          if (data.hasOwnProperty('discount_codes') && Object.values(data.discount_codes).length > 0) {
            foundDiscountCodes = Object.values(data.discount_codes || {})
              .filter(d => d.applicable)
              .map(d => d.code);
            appliedDiscountCode = foundDiscountCodes.join(',');
          }

          sentDiscountCodes.forEach((sentDiscountCode) => {
            if (!foundDiscountCodes.includes(sentDiscountCode)) {
              errorDiscountCode += `${sentDiscountCode},`;
            }
          });

          if (errorDiscountCode !== '') {
            errorDiscountCode = errorDiscountCode.slice(0, -1);
          }

          return CartService.update({
            attributes: {
              applied_discount_codes: appliedDiscountCode,
              error_discount_codes: errorDiscountCode,
            },
          });
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          // Updates the cart drawer
          fetchCartDrawer();
        });
  }

  if (!!(cartItemRemoves) && cartItemRemoves.length > 0) {
    cartItemRemoves.forEach((cartItemRemove) => {
      cartItemRemove.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        updateCartState(CART_STATE.BUSY);

        cartChange({
          id: event.currentTarget.dataset.key,
          quantity: 0,
          sections: sectionsToFetch
        });
      });
    });
  }

  if (!!(quantityInputs) && quantityInputs.length > 0) {
    quantityInputs.forEach((input) => {
      input.addEventListener('update', (event) => {
        event.stopImmediatePropagation();

        updateCartState(CART_STATE.BUSY);

        const updates = {};

        updates[event.detail.key] = Number(event.detail.value);

        cartUpdate({
          updates,
          sections: sectionsToFetch
        });
      });
    });
  }

  if (!!(cartControls) && !!(cartDrawer)) {
    cartDrawer.parentElement.style.setProperty('--cart-drawer-footer-height', `${cartControls.offsetHeight}px`);
  }

  const cartObserver = new MutationObserver((mutations, observer) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const cartItemRemoves = node.querySelectorAll('.js-cart-item__remove');
          const quantityInputs = node.querySelectorAll('.js-cart-quantity-input');

          if (!!(cartItemRemoves) && cartItemRemoves.length > 0) {
            cartItemRemoves.forEach((cartItemRemove) => {
              cartItemRemove.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();

                updateCartState(CART_STATE.BUSY);

                cartChange({
                  id: event.currentTarget.dataset.key,
                  quantity: 0,
                  sections: sectionsToFetch
                });
              });
            });
          }

          if (!!(quantityInputs) && quantityInputs.length > 0) {
            quantityInputs.forEach((input) => {
              input.addEventListener('update', async (event) => {
                event.stopImmediatePropagation();

                updateCartState(CART_STATE.BUSY);

                const updates = {};

                updates[event.detail.key] = Number(event.detail.value);

                cartUpdate({
                  updates,
                  sections: sectionsToFetch,
                });
              });
            });
          }
        }
      });
    });
  });

  cartObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  /**
   * Gift with Purchase
   */

  let gwpSections = document.querySelectorAll('.shopify-section-group-gwp');
  let gwpItems = document.querySelectorAll('[name="gwp"]');
  let gwpUpdates = [];

  if (!!(gwpItems) && gwpItems.length > 0) {
    gwpItems.forEach((gwp) => {
      if (gwp.dataset.type === 'add' && gwp.value.startsWith('{')) {
        const data = JSON.parse(gwp.value);
        const uuid = window.crypto.randomUUID();

        if (data.hasOwnProperty('add')) {
          data.add.properties['_uuid'] = uuid;

          gwpUpdates.push(CartService.add(data.add));
        }

        setTimeout(() => {
          gwpUpdates.push(CartService.update(data.update));
        }, 1000);

        gwp.remove();
      } else if (gwp.dataset.type === 'remove' && node.value.startsWith('{')) {
        gwpUpdates.push(CartService.update(JSON.parse(gwp.value)));

        gwp.remove();
      }
    });

    Promise.all(gwpUpdates)
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setTimeout(() => {
          fetchCartDrawer(false);
        }, 1000);
      });
  }

  const gwpObserver = new MutationObserver((mutations, observer) => {
    mutations.forEach((mutation) => {
      gwpUpdates = [];

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          gwpSections = document.querySelectorAll('.shopify-section-group-gwp');

          if (!!(gwpSections) && gwpSections.length > 0) {
            gwpSections.forEach((section) => {
              if (!section.hasAttribute('data-is-being-observed')) {
                gwpObserver.observe(section, {
                  childList: true,
                  subtree: true
                });

                section.setAttribute('data-is-being-observed', 'true');
              }
            });
          }

          if (node.dataset.type === 'add' && node.value.startsWith('{')) {
            const data = JSON.parse(node.value);
            const uuid = window.crypto.randomUUID();

            if (data.hasOwnProperty('add')) {
              data.add.properties['_uuid'] = uuid;

              gwpUpdates.push(CartService.add(data.add));
            }

            setTimeout(() => {
              gwpUpdates.push(CartService.update(data.update));
            }, 1000);

            node.remove();
          } else if (node.dataset.type === 'remove' && node.value.startsWith('{')) {
            gwpUpdates.push(CartService.update(JSON.parse(node.value)));

            node.remove();
          }
        }
      });

      Promise.all(gwpUpdates)
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setTimeout(() => {
            fetchCartDrawer(false);
          }, 1000);
        });
    });
  });

  if (!!(gwpSections) && gwpSections.length > 0) {
    gwpSections.forEach((section) => {
      gwpObserver.observe(section, {
        childList: true,
        subtree: true
      });

      section.setAttribute('data-is-being-observed', 'true');
    });
  }
}

if(['interactive', 'complete'].includes(document.readyState)){
  initializeCartHandlers();
} else {
  document.addEventListener('DOMContentLoaded', initializeCartHandlers);
}

/**
 * Item Personalization
 */

if (!customElements.get('item-personalization')) {
  customElements.define('item-personalization', class ItemPersonalization extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.editButton = this.querySelector('.js-cart-item__personalization__header__edit-button');
      this.formInputs = this.querySelectorAll('input');
      this.saveButton = this.querySelector('.js-cart-item__personalization__edit-form__save-button');

      this.initialProperties = {};

      if (!!(this.formInputs) && this.formInputs.length > 0) {
        this.formInputs.forEach((input) => {
          this.initialProperties[input.name] = input.value;
        });
      }

      this.editButton.addEventListener('click', this.handleEditButtonClick.bind(this));
      this.saveButton.addEventListener('click', this.handleSaveButtonClick.bind(this));
    }

    /**
     * Handles the edit button click
     *
     * @param {Event} event - The event object
     */
    handleEditButtonClick(event) {
      this.toggleAttribute('data-is-editing');
    }

    /**
     * Handles the save button click
     *
     * @param {Event} event - The event object
     */
    handleSaveButtonClick(event) {
      if (!!(this.formInputs) && this.formInputs.length > 0) {
        const currentProperties = {};
        const changeData = {
          id: this.dataset.itemKey,
          quantity: Number(this.dataset.itemQuantity),
        };
        let hasProperties = false;

        updateCartState(CART_STATE.BUSY);

        this.formInputs.forEach((input) => {
          currentProperties[input.name] = input.value;
        });

        if (JSON.stringify(currentProperties) === JSON.stringify(this.initialProperties)) {
          this.toggleAttribute('data-is-editing');

          return;
        }

        this.formInputs.forEach((input) => {
          if (!hasProperties && input.name.startsWith('properties[') && !input.name.startsWith('properties[_')) {
            hasProperties = true;

            changeData['properties'] = {};
          }

          if (input.name === 'properties[_personalization]') {
            const personalizationFormData = [];

            this.formInputs.forEach((input) => {
              if (input.hasAttribute('data-key')) {
                personalizationFormData.push({
                  key: input.dataset.key,
                  value: input.value,
                });
              }
            });

            input.value = JSON.stringify(personalizationFormData);
          }

          changeData['properties'][input.name.replace('properties[', '').replace(']', '')] = input.value;
        });

        CartService.change(changeData)
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.removeAttribute('data-is-editing');

            // Updates the cart drawer
            fetchCartDrawer(true);
          });
      }
    }
  });
}

/**
 * Accelerated Checkout Buttons
 */

if (!customElements.get('accelerated-checkout-buttons')) {
  customElements.define('accelerated-checkout-buttons', class AcceleratedCheckoutButtons extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('.dynamic-button');
      this.component = this.dataset.component;

      this.buttons.forEach((button) => {
        button.addEventListener('click', this.handleClick.bind(this));
      });

      // Checks if the device is an Apple device
      if (window.ApplePaySession) {
        this.querySelector('.dynamic-button--apple-pay')?.removeAttribute('hidden');
        this.querySelector('.dynamic-button--apple-pay')?.parentElement.setAttribute('data-button-count', 3);
      }
    }

    /**
     * Handles the click event for the faux accelerated checkout buttons
     *
     * @param {Event} event - The event object
     */
    handleClick(event) {
      const button = event.target;
      const buttonType = button.dataset.buttonType;
      const form = button.closest('form');
      const isShopPay = (buttonType === 'shop-pay');

      if (!!(form)) {
        const data = new FormData(form);
        const updates = {
          attributes: {}
        };
        let hasUpdates = false;

        if (this.component === 'product-form') {
          // Personalization functionality
          const personalizationForm = form.querySelector('.js-personalization-form');

          if (!!(personalizationForm)) {
              const personalizationFormData = [];

              personalizationForm.querySelectorAll('input')?.forEach((input) => {
                  personalizationFormData.push({
                      key: input.dataset.key,
                      value: input.value
                  });
              });

              data.append('properties[_personalization]', JSON.stringify(personalizationFormData));
          }

          const uuidInputs = form.querySelectorAll('.js-product-uuid-input');
          const idInput = form.querySelector('[name="id"]');
          let doesNotHaveUuid = true;

          if (!!(idInput) && !!(uuidInputs) && uuidInputs.length > 0) {
            uuidInputs.forEach((input) => {
              if (Number(input.dataset.variantId) === Number(idInput.value)) {
                input.disabled = false; // Enable the input if the variant is the same
                doesNotHaveUuid = false;
              } else {
                input.disabled = true; // Disable the input if the variant is different
              }
            });
          }

          if (doesNotHaveUuid && !!(idInput)) {
            const uuid = window.crypto.randomUUID();

            data.append('properties[_uuid]', uuid);

            // Add element in case customer wants to add more from the same product form
            form.insertAdjacentHTML('beforeend', `<input type="hidden" name="properties[_uuid]" value="${uuid}" data-variant-id="${idInput.value}" class="js-product-uuid-input">`);
          }

          // Add cart attributes if necessary
          const attributeInputs = form.querySelectorAll('[data-attribute]');

          if (!!(attributeInputs) && attributeInputs.length > 0) {
            attributeInputs.forEach((input) => {
              updates.attributes[input.dataset.attribute] = input.value;
              hasUpdates = true;
            });
          }
        }

        data.append('return_to', `/checkout?${isShopPay ? 'payment=shop_pay' : 'skip_shop_pay=true'}`);

        form.insertAdjacentHTML('beforeend', `<input type="hidden" name="return_to" value="/checkout?${isShopPay ? 'payment=shop_pay' : 'skip_shop_pay=true'}">`);

        if (this.component === 'product-form') {
          CartService.clear()
            .then(() => {
              if (hasUpdates) {
                return CartService.update(updates);
              } else {
                return Promise.resolve();
              }
            })
            .then(() => {
              cartAdd(data, isShopPay, true);
            })
            .catch((error) => {
              console.error(error);
            });
        } else if (this.component === 'cart-details') {
          cartAdd(data, isShopPay, true);
        }
      }
    }
  });
}

/**
 * Cart Add-Ons
 */

if (!customElements.get('cart-addon')) {
  customElements.define('cart-addon', class CartAddon extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.input = this.querySelector('input');

      if (!!(this.input)) {
        this.input.addEventListener('change', this.handleChange.bind(this));
      }
    }

    /**
     * Handles the change event for the cart add-on
     *
     * @param {Event} event - The event object
     */
    handleChange(event) {
      let addonKey = '';
      let parentKey = this.input.dataset.parentKey;
      let parentUUID = this.input.dataset.parentUuid;

      updateCartState(CART_STATE.BUSY);

      if (event.currentTarget.hasAttribute('data-key')) {
        addonKey = event.currentTarget.dataset.key;
      }

      if (event.currentTarget.checked && this.input.dataset.parentProperties.startsWith('[')) {
        const parentProperties = Object.fromEntries(JSON.parse(this.input.dataset.parentProperties));

        if (parentProperties.hasOwnProperty('_add_on_variants')) {
          parentProperties['_add_on_variants'] = JSON.parse(parentProperties['_add_on_variants']);

          parentProperties['_add_on_variants'].push({
            'id': this.input.value,
            'add_on_type': this.input.dataset.type,
            'cost': Number(this.input.dataset.price),
          });
        } else {
          parentProperties['_add_on_variants'] = [];

          parentProperties['_add_on_variants'].push({
            'id': this.input.value,
            'add_on_type': this.input.dataset.type,
            'cost': Number(this.input.dataset.price),
          });
        }

        parentProperties['_add_on_variants'] = JSON.stringify(parentProperties['_add_on_variants']);

        CartService.change({
          id: parentKey,
          quantity: Number(this.input.dataset.parentQuantity),
          properties: parentProperties,
        })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            // Updates the cart drawer
            fetchCartDrawer(true);
          });
      } else {
        if (addonKey !== '') {
          const idToRemove = this.input.value;

          if (idToRemove !== '') {
            CartService.getCart()
              .then((data) => {
                for (const item of data.items) {
                  if (
                    item.properties.hasOwnProperty('_uuid') &&
                    item.properties['_uuid'] === parentUUID
                  ) {
                    if (item.properties.hasOwnProperty('_add_on_variants')) {
                      const addOnVariants = JSON.parse(
                        item.properties['_add_on_variants']
                      );

                      if (addOnVariants.length > 0) {
                        addOnVariants.forEach((addOnVariant) => {
                          if (addOnVariant.id === idToRemove) {
                            addOnVariants.splice(
                              addOnVariants.indexOf(addOnVariant),
                              1
                            );
                          }
                        });
                      }

                      if (addOnVariants.length > 0) {
                        item.properties['_add_on_variants'] = JSON.stringify(addOnVariants);
                      } else {
                        delete item.properties['_add_on_variants'];
                      }
                    }

                    return CartService.change({
                      id: item.key,
                      quantity: item.quantity,
                      properties: item.properties,
                    });
                  }
                }
              })
              .catch((error) => {
                console.error(error);
              })
              .finally(() => {
                // Updates the cart drawer
                fetchCartDrawer(true);
              });
          }
        }
      }
    }
  });
}

/**
 * Cart Discount Code
 */

if (!customElements.get('discount-code-component')) {
  customElements.define('discount-code-component', class CartDiscount extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.combinableDiscountPrefixes = this.dataset.combinableDiscountPrefixes.split(',,,');

      if (!Array.isArray(this.combinableDiscountPrefixes)) {
        this.combinableDiscountPrefixes = [this.combinableDiscountPrefixes];
      }

      this.discountCode = this.dataset.discountCode;
      this.discountCodeInput = this.querySelector('.js-cart-discount-code__input');
      this.discountCodeBtn = this.querySelector('.js-cart-discount-code__btn');
      this.discountCodeMessageRemoveButton = this.querySelectorAll('.js-cart-discount-code__message__item__remove-button');
      this.MAX_APPLIED_DISCOUNTS = Number(this.dataset.maxLimit);
      this.MAX_APPLIED_DISCOUNTS_LIMIT_MESSAGE = this.dataset.maxLimitMessage;
      this.DISCOUNT_ALREADY_APPLIED_MESSAGE = this.dataset.alreadyThereMessage;

      if (!!(this.discountCodeInput)) {
        this.discountCodeInput.addEventListener('keyup', this.applyDiscountCode.bind(this));
      }

      if (!!(this.discountCodeBtn)) {
        this.discountCodeBtn.addEventListener('click', this.applyDiscountCode.bind(this));
      }

      if (!!(this.discountCodeMessageRemoveButton)) {
        this.discountCodeMessageRemoveButton.forEach((button) => {
          button.addEventListener('click', this.removeDiscountCode.bind(this));
        });
      }
    }

    #handleDiscountError(errorMessage, stateAfterErrorSet = CART_STATE.READY) {
        const errorMessageHTML = `<div class="cart-discount-code__message__item cart-discount-code__message__item--is-error"><p>${errorMessage}</p></div>`;

        this.querySelector('.cart-discount-code__message').insertAdjacentHTML('afterbegin', errorMessageHTML);

        updateCartState(stateAfterErrorSet);
    }

    /**
     * Applies the discount code to the cart
     *
     * @param {Event} event
     */
    applyDiscountCode(event) {
      // Replace trailing commas and multiple commas with single commas in the input value to prevent empty discount codes from being sent
      this.discountCodeInput.value = String(this.discountCodeInput.value ?? '').toUpperCase().replace(/,+/g, ',').replace(/^,|,$/g, '').trim();

      if (event.currentTarget.name === 'discount_code') {
        if (event.key !== 'Enter') {
          return;
        }
      }

      updateCartState(CART_STATE.BUSY);

      const appliedDiscountCodes = (this.discountCode ?? '').split(',');

      const enteredDiscountCodes = String(this.discountCodeInput.value).split(',');
      const isEveryEnteredDiscountCombinable = enteredDiscountCodes.every((code) => {
        return this.combinableDiscountPrefixes.some((prefix) => code.startsWith(prefix));
      });

      const areAllEnteredCodesAlreadyApplied = enteredDiscountCodes.every((code) => {
        return appliedDiscountCodes.includes(code);
      });
      
      if (areAllEnteredCodesAlreadyApplied && this.discountCode !== '') {
        this.#handleDiscountError(this.DISCOUNT_ALREADY_APPLIED_MESSAGE);
        return;
      }

      const isEveryAppliedDiscountCombinable = appliedDiscountCodes.every((code) => {
        return this.combinableDiscountPrefixes.some((prefix) => code.startsWith(prefix));
      });

      let discountCodesToSend = [...appliedDiscountCodes];

      if (isEveryEnteredDiscountCombinable && isEveryAppliedDiscountCombinable) {
        discountCodesToSend = [...appliedDiscountCodes].concat(enteredDiscountCodes);
      } else {
        discountCodesToSend = [...enteredDiscountCodes];
      }

      discountCodesToSend = [...new Set(discountCodesToSend)];

      if (discountCodesToSend.length > this.MAX_APPLIED_DISCOUNTS) {
        this.#handleDiscountError(this.MAX_APPLIED_DISCOUNTS_LIMIT_MESSAGE);
        return;
      }

      const discountsToSendString = discountCodesToSend.join(',');

      this.sentDiscountCodes = discountsToSendString.split(',');

      CartService.update({ discount: discountsToSendString })
        .then((data) => {
          const appliedDiscountCodes = Object.values(data?.discount_codes ?? {})
              .filter(d => d.applicable)
              .map(d => d.code);
          const sentDiscountCodes = this.sentDiscountCodes;

          const errorDiscountCodes = sentDiscountCodes.map((sentDiscountCode) => {
            if (!appliedDiscountCodes.includes(sentDiscountCode)) {
              return sentDiscountCode;
            }
            return null;
          }).filter(Boolean);

          return CartService.update({
            attributes: {
              applied_discount_codes: appliedDiscountCodes.join(','),
              error_discount_codes: errorDiscountCodes.join(','),
            },
          });
        })
        .then((data) => {
          fetchCartDrawer(true);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          updateCartState(CART_STATE.READY);
        });
    }

    /**
     * Removes the discount code from the cart
     *
     * @param {Event} event 
     */
    removeDiscountCode(event) {
      let appliedDiscountCodes = this.discountCode.split(',');

      appliedDiscountCodes.splice(appliedDiscountCodes.indexOf(event.currentTarget.dataset.discountCode), 1);
      appliedDiscountCodes = appliedDiscountCodes.join(',');

      updateCartState(CART_STATE.BUSY);

      CartService.update({ discount: appliedDiscountCodes })
        .then((data) => {
          const newAppliedDiscountCodes = Object.values(data?.discount_codes ?? {}).map((discount) => {
            if (discount.applicable) {
              return discount.code;
            }
            return null;
          }).filter(Boolean);

          return CartService.update({
            attributes: {
              applied_discount_codes: newAppliedDiscountCodes.join(','),
            },
          });
        })
        .then((data) => {
          fetchCartDrawer(true);
        })
        .catch((error) => {
          console.error(error);
          updateCartState(CART_STATE.READY);
        });
    }
  });
}

/**
 * Fetches cart updates when the window regains focus
 */

window.addEventListener('focus', (event) => {
  updateCartState(CART_STATE.BUSY);

  fetchCartDrawer(false);
});